const COLORS = {
  PRIMARY: "primary",
};

const SIZES = {
  MEDIUM: "medium",
};

export { COLORS, SIZES };
